const cardDivStyle = {
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "10px",
  marginBottom: "10px",
  width: "95%",
  padding: "10px",
  borderRadius: "10px",
  backgroundColor: "rgba(100,100,100,.75)",
};

export { cardDivStyle };
